import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "quick_reference_all_svg__mask0_7072_116",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }, [
      _createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#quick_reference_all_svg__mask0_7072_116)" }, [
      _createElementVNode("path", {
        d: "M5 4V10.025V10V20V4ZM7 14H10.5C10.65 13.6167 10.8333 13.2583 11.05 12.925C11.2667 12.5917 11.5167 12.2833 11.8 12H7V14ZM7 18H10.175C10.0917 17.6667 10.0375 17.3333 10.0125 17C9.9875 16.6667 9.99167 16.3333 10.025 16H7V18ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V4C3 3.45 3.19583 2.97917 3.5875 2.5875C3.97917 2.19583 4.45 2 5 2H13L19 8V10.5C18.6833 10.3667 18.3583 10.2625 18.025 10.1875C17.6917 10.1125 17.35 10.0583 17 10.025V9H12V4H5V20H11.025C11.2917 20.4 11.5917 20.7708 11.925 21.1125C12.2583 21.4542 12.625 21.75 13.025 22H5ZM16.5 19C17.2 19 17.7917 18.7583 18.275 18.275C18.7583 17.7917 19 17.2 19 16.5C19 15.8 18.7583 15.2083 18.275 14.725C17.7917 14.2417 17.2 14 16.5 14C15.8 14 15.2083 14.2417 14.725 14.725C14.2417 15.2083 14 15.8 14 16.5C14 17.2 14.2417 17.7917 14.725 18.275C15.2083 18.7583 15.8 19 16.5 19ZM21.6 23L18.9 20.3C18.55 20.5333 18.1708 20.7083 17.7625 20.825C17.3542 20.9417 16.9333 21 16.5 21C15.25 21 14.1875 20.5625 13.3125 19.6875C12.4375 18.8125 12 17.75 12 16.5C12 15.25 12.4375 14.1875 13.3125 13.3125C14.1875 12.4375 15.25 12 16.5 12C17.75 12 18.8125 12.4375 19.6875 13.3125C20.5625 14.1875 21 15.25 21 16.5C21 16.9333 20.9417 17.3542 20.825 17.7625C20.7083 18.1708 20.5333 18.55 20.3 18.9L23 21.6L21.6 23Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }